<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <!--    <div>-->
        <!--      <v-radio-group v-model="product.show">-->
        <!--        <v-radio label="نمایش بصورت تب" value="tab"></v-radio>-->
        <!--        <v-radio label="نمایش بصورت آکاردئون" value="accordion"></v-radio>-->
        <!--      </v-radio-group>-->
        <!--    </div>-->
        <v-expansion-panels class="pa-2 pb-8" focusable>
          <v-expansion-panel
            v-for="(category, index) in value.details"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header>
              <span>
                <span v-if="index !== editGaleryName">
                  {{ category.name }}
                </span>
                <v-icon>{{ category.icon }}</v-icon>
                <div class="rowinfo" v-if="index === editGaleryName">
                  <v-text-field
                    v-model="category.name"
                    append-icon="check"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="نام دسته"
                    outlined
                    @click.stop
                    @click:append.stop="editGaleryName = -1"
                  />
                  <help-info
                    v-if="index === 0"
                    :element-name="`${serviceName}-${componentName}-category-name`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام دسته"
                  />
                </div>

                <!--            append-outer-icon="mdi-emoticon-outline"-->
                <!--            @click:append-outer.stop="showIcon = true"-->
                <v-btn
                  icon
                  small
                  @click.stop="editGaleryName = index"
                  v-if="index !== editGaleryName"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>

                <!--            <icon-picker v-if="showIcon" key="icon" v-model="category.icon" class="flex col-md-12"-->
                <!--                         @closeIt="showIcon=false"/>-->
              </span>

              <v-btn
                v-if="value.details.length !== 1"
                icon
                max-width="36"
                @click.stop="deleteCat(index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <help-info
                v-if="index === -1"
                left
                :element-name="`${serviceName}-${componentName}-data-features`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="ویژگی"
              />
            </v-expansion-panel-header>

            <v-expansion-panel-content class="mt-4">
              <v-card flat>
                <extra-fileds v-model="category.value"></extra-fileds>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-card-actions class="col-md-12 px-2 pt-6">
            <div class="rowinfo" style="width: 100% !important">
              <v-btn
                color="success"
                outlined
                @click="addCategory"
                class="contentinfo"
              >
                افزودن ویژگی جدید
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-addCategory`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="افزودن ویژگی جدید"
              />
            </div>
          </v-card-actions>
        </v-expansion-panels>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import ExtraFileds from "@/view/components/Product/extraFileds";
import IconPicker from "@/view/components/IconPicker";

export default {
  name: "features",
  components: { IconPicker, ExtraFileds },
  props: {
    value: {
      default: {
        show: "accordion",
        details: [
          {
            name: "ویژگی های محصول ",
            icon: "",
            showIt: false,
            value: [
              {
                label: "",
                value: "اندازه هربرگ : ۲۰۵ * ۲۰۰ میلیمتر",
                icon: "",
                name: "",
                link: "",
              },
            ],
          },
        ],
      },
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "feature",
      tabs: 0,
      editGaleryName: -1,
      showIcon: false,
    };
  },
  methods: {
    resetOther(product, name) {
      const current = product[name];

      product.image = undefined;
      product.color = undefined;
      product.icon = undefined;

      product[name] = current;
    },
    addDetail(i, index) {
      this.value.details[index].value.push({
        label: "",
        value: "",
      });

      this.$nextTick(() => {
        this.$emit("input", this.value);
      });
    },
    deleteDetail(i, index) {
      this.value.details[index].value.splice(i, 1);
    },
    deleteCat(index) {
      this.value.details.splice(index, 1);
    },
    addCategory() {
      this.value.details.push({
        name: "ویژگی ",
        showIt: false,
        value: [
          {
            label: "",
            value: "",
          },
        ],
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.$emit("input", this.value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}
</style>
